export const ISRAEL_TAX_REGULATION_UPDATE_SHOWN_TODAY = 'israelTaxRegulationUpdate_ShownToday';

export const ISRAEL_TAX_REGULATION_UPDATE_BLOCKED_BY_USER_FIRST_CYCLE =
    'israelTaxRegulationUpdate_isBlockedByUserFirstCycle';

export const ISRAEL_TAX_REGULATION_UPDATE_BLOCKED_BY_USER_SECOND_CYCLE =
    'israelTaxRegulationUpdate_isBlockedByUserSecondCycle';
